<template>
  <header-sub-component v-if="$store.state.auth?.oidc?.user" />
    <section class="lras mt-3">
        <div class="lras__list">
            <template v-if="isLoading">
                <p>Подождите... Идет загрузка данных</p>
            </template>
            <template v-else-if="!items">
                <p>Ничего не найдено</p>
            </template>
            <template v-else>
                <template v-for="ippsu in items" v-bind:key="ippsu.id">
                    <drop-down class="mb-2" :label="
                      (ippsu.ippsuNumber ? '№' + ippsu.ippsuNumber : '') 
                      + ' от ' + $moment.format(ippsu.date, 'DD.MM.YYYY') + 
                      (ippsu.journalIppsuServices.length ? ' до ' + $momentFormat(ippsu.journalIppsuServices[0].endDate, 'DD.MM.YYYY') : '') +
                      ', ' +
                      (ippsu.statusString == '' ? 'Без статуса' : ippsu.statusString)
                    ">

                        <div class="m-3 mt-0">

                        <div class="ippsu-row row border-bottom mb-2 pb-2" v-if="ippsu.fileId && ippsu.file">
                            <div class="col-4 p-0 control-label">Файл ИППСУ</div>
                            <div class="col">
                                <file-download :file="ippsu.file" />
                            </div>
                        </div>                                                    

                        <div class="ippsu-row row border-bottom mb-2 pb-2">
                            <div class="col-4 p-0 control-label">Индивидуальная программа предоставления социальных услуг разработана</div>
                            <div class="col">{{ ippsu.ippsuType ?? ippsu.isFirst ? "впервые" : "повторно" }}</div>
                        </div>

                        <div class="ippsu-row row border-bottom mb-2 pb-2">
                            <div class="col-4 p-0 control-label">Форма (формы) социального обслуживания</div>
                            <div class="col">{{ usedServiceForms(ippsu) }}</div>
                        </div>
                        </div>

                        <template v-if="ippsu.journalIppsuServices && ippsu.journalIppsuServices.length > 0">
                            <h4>Виды социальных услуг</h4>
                        <div class="table-inner mb-4">                            
                            <table class="table table-custom border-light">
                                <thead>
                                    <tr>
                                      <th width="6%">№ п/п</th>
                                      <th>Наименование услуги</th>
                                      <th>Форма социального обслуживания</th>
                                      <th>Тип услуги</th>
                                      <th>Рекомендуемые поставщики</th>
                                      <th>Периодичность предоставления услуги</th>
                                      <th>Срок предоставления услуги</th>
                                      <th>Причины отказа</th>
                                      <th>Дата отказа</th>
                                      <th>Кто отказал</th>
                                    </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(service, index) in ippsu.journalIppsuServices" :key="service.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ service.serviceName }}</td>
                                    <td>{{ service.socialTypeInfo }}</td>
                                    <td>{{ service.serviceType }}</td>
                                    <td>{{ service.recommendedSuppliers }}</td>
                                    <td>{{ service.period }}</td>
                                    <td>{{ $momentFormat(service.endDate, "DD.MM.YYYY") }}</td>
                                    <td>{{ service.refuseReason }}</td>
                                    <td>{{ service.refuseDate }}</td>
                                    <td>{{ service.refusedBy }}</td>
                                  </tr>
                                </tbody>
                            </table>
                        </div>
                        </template>

                        <template v-if="ippsu.journalIppsuContracts && ippsu.journalIppsuContracts.length">
                          <h4>Заключенные договоры</h4>
                          <div class="table-inner mb-4">
                          <table class="table table-custom border-light">
                            <thead>
                              <tr>
                                <th width="6%">№ п/п</th>
                                <th>Дата заключения договора</th>
                                <th>Номер договора</th>
                                <th>Дата начала обслуживания по договору</th>
                                <th>Дата окончания обслуживания по договору</th>
                                <th>Краткое наименование организации</th>
                                <th>ИНН организации</th>
                                <th>КПП организации</th>
                                <th>Адрес места нахождения поставщика социальных услуг</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(contract, index) in ippsu.journalIppsuContracts" :key="contract.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ getNonEmptyDate(contract.contractDate) }}</td>
                                <td>{{ contract.contractNumber }}</td>
                                <td>{{ getNonEmptyDate(contract.contractStartDate) }}</td>
                                <td>{{ getNonEmptyDate(contract.contractEndDate) }}</td>
                                <td>{{ contract.organizationName }}</td>
                                <td>{{ contract.organizationInn }}</td>
                                <td>{{ contract.organizationKpp }}</td>
                                <td>{{ contract.organizationAddress }}</td>
                              </tr>
                            </tbody>
                          </table>
                          </div>
                        </template>
                    </drop-down>
                </template>
            </template>
        </div>
    </section>
</template>
<script>

import DropDown from "../components/DropDown";
import API from '../api/ippsu'
import FileDownload from '../../../common/components/FileDownload.vue';
import HeaderSubComponent from "../../../common/components/HeaderSubComponent";

export default {
    name: "ippsu",
    components: {
      HeaderSubComponent,

        DropDown,
        FileDownload
    },
    data() {
        return {
            isLoading: false,
            items: []
        }
    },
    created() {
        this.loadList();
    },
    methods: {
        loadList() {
            this.isLoading = true;
            API.getList().then(response => {
                this.items = response.data;                
                console.log(this.items, "------------ getList");
                this.isLoading = false;
            });
        },
        usedServiceForms(ippsu) {
            return ippsu.journalIppsuServices.map(x => x.socialTypeInfo ).filter((v, i, a) => a.indexOf(v) === i).join(', ')
            },
        getNonEmptyDate(date) {
          return moment.utc(date).isAfter(this.minDate) ? this.$momentFormat(date, "DD.MM.YYYY") : "";
        }
    },
}
</script>
<style lang="scss" scoped>
@media (max-width: 767px){
  .ippsu-row{
    flex-wrap: wrap;
    .col,.col-4{
      flex: none;
      width: 100%;
      padding-left: 0px;
      padding-right: 0px;
    }
  }
}

</style>